"use client";

import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { chaptersData } from "@/data/chapters";
import { LazyVideoPlayer } from "./LazyVideoPlayer";
import styles from "./ChapterSection.module.css";

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

export function ChapterStackSection() {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const panels = gsap.utils.toArray<HTMLElement>(".chapterStickyPanel");
    if (panels.length === 0) return;

    const ctx = gsap.context(() => {
      panels.forEach((panel, index) => {
        // Only run native structural pinning anchors across sequential layers without transforming alpha levels
        if (index === panels.length - 1) return;

        ScrollTrigger.create({
          trigger: panel,
          start: "top top",
          end: "bottom top",
          pin: true,
          pinSpacing: false, // Allows lower cards to cleanly scroll over top without spatial gaps
          invalidateOnRefresh: true,
        });
      });
    }, wrapperRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={wrapperRef} className={styles.scrollWrapper}>
      {chaptersData.map((item) => (
        <div 
          key={item.id} 
          className={`${styles.stickyPanel} chapterStickyPanel`}
        >
          {/* Complete background media loop structure */}
          <div className={styles.backgroundVideoContainer}>
            <LazyVideoPlayer src={item.videoUrl} />
          </div>

          {/* Floated copy block overlay layer */}
          <div className={`${styles.contentContainer} ${item.layoutSide === "right" ? styles.alignRight : styles.alignLeft}`}>
            <div className={styles.textBlock}>
              <span className={styles.chapterTag}>{item.chapterNumber}</span>
              <h2 className={styles.headlineGroup}>
                <span className={styles.headlineSolid}>{item.titleSolid}</span>
                <span className={styles.headlineOutline}>{item.titleOutline}</span>
              </h2>
              <p className={styles.descriptionText}>
                {item.description}
              </p>
            </div>
          </div>

        </div>
      ))}
    </div>
  );
}